import {
  ScanSearchIcon,
  ClockIcon,
  RotateCwIcon,
  MagnetIcon,
  TrendingDownIcon,
  CalendarXIcon,
  SearchIcon,
  ScaleIcon,
  ClipboardListIcon,
  ActivityIcon,
  Grid3x3Icon,
  RulerIcon,
  MicroscopeIcon,
  CompassIcon,
  ListChecksIcon,
} from 'lucide-react';

export const painPoints = [
  {
    icon: ScanSearchIcon,
    title: 'The Setup Looks Great… But You’re Not Sure the Movement Is Realistic.',
    body: 'You see the desired tooth position on your screen, but you still have questions about whether the planned movement can be expressed predictably. You want a clearer way to evaluate the biomechanics before approving the plan.',
  },
  {
    icon: ClockIcon,
    title: 'You’re Spending Too Much Time Reviewing Treatment Plans.',
    body: 'Every case presents different movement combinations, anatomical considerations, and planning decisions. You need a structured reference instead of repeatedly searching through scattered resources.',
  },
  {
    icon: RotateCwIcon,
    title: 'Certain Movements Keep Giving You Trouble.',
    body: 'Rotations, extrusions, intrusions, torque control… You know these movements can present challenges, but you want a clearer understanding of the factors affecting their predictability.',
  },
  {
    icon: MagnetIcon,
    title: 'You’re Unsure When Attachments or Additional Mechanics Deserve Closer Evaluation.',
    body: 'You don’t want to accept automatically generated features without understanding their biomechanical purpose. You want to evaluate each decision based on the clinical objective.',
  },
  {
    icon: TrendingDownIcon,
    title: 'The Patient’s Teeth Aren’t Tracking as Expected.',
    body: 'Now you’re trying to understand whether the discrepancy relates to fit, compliance, biomechanics, movement complexity, or another clinical factor. You need an organized assessment pathway.',
  },
  {
    icon: CalendarXIcon,
    title: 'Unplanned Appointments Are Affecting Your Clinical Efficiency.',
    body: 'When treatments require additional assessment, adjustments, or refinement, they may consume more chair time than originally anticipated. You want to recognize avoidable planning risks earlier.',
  },
];

export const roadmapSteps = [
  { icon: SearchIcon, step: 'Identify', body: 'Recognize the movement you’re planning and its potential limitations.' },
  { icon: ScaleIcon, step: 'Evaluate', body: 'Review the anatomical, biomechanical, and treatment-related factors that may affect predictability.' },
  { icon: ClipboardListIcon, step: 'Plan', body: 'Compare relevant clinical considerations before finalizing the digital setup.' },
  { icon: ActivityIcon, step: 'Monitor', body: 'Use structured checkpoints to assess movement expression throughout treatment.' },
];

export const tools = [
  { icon: Grid3x3Icon, title: 'Movement Risk Matrices', body: 'Compare relevant predictability considerations across different tooth movements.' },
  { icon: RulerIcon, title: 'Digital Setup Review Frameworks', body: 'Organize the clinical factors to assess before approving a plan.' },
  { icon: MicroscopeIcon, title: 'Biomechanical Reference Diagrams', body: 'Visualize important movement-control principles.' },
  { icon: CompassIcon, title: 'Clinical Decision Pathways', body: 'Navigate common planning questions through structured evaluation steps.' },
  { icon: ListChecksIcon, title: 'Treatment Monitoring Checklists', body: 'Review important checkpoints during clinical follow-up.' },
];

export const simulationFailures = [
  'A rotation doesn’t fully express.',
  'An extrusion becomes more difficult than expected.',
  'A tooth stops tracking.',
];
